<template>
  <div class="dialog-container share-dialog" v-show="visible" @click="hide()">
    <div class="dialog-content" @click.stop="visible=true">
      <div class="dialog-close" @click.stop="hide()"></div>
      <h2 v-if="!score"><img src="@/assets/img/icon-share.svg"> Share This Game</h2>
      <h2 v-if="score" class="score"><img src="@/assets/img/icon-share.svg"> Share Your Score</h2>
      <p v-if="!score">Share this game via your preferred social network or direct email by clicking a button below</p>
      <p v-if="score" class="score">Share your high score via your preferred social network or direct email by clicking a button below</p>
      <div class="share-icons">
        <div class="share-icon" @click="share('facebook')"><img src="@/assets/img/icon-facebook.svg" width="40"></div>
        <div class="share-icon" @click="share('linkedin')"><img src="@/assets/img/icon-linkedin.svg" width="40"></div>
        <div class="share-icon" @click="share('twitter')"><img src="@/assets/img/icon-twitter.svg" width="40"></div>
        <div class="share-icon" @click="share('email')"><img src="@/assets/img/icon-email.svg" width="40"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comp',
  data: function () {
    return {
      visible: false
    }
  },
  mounted: function () {
    this.visible = this.active
  },
  methods: {
    hide: function () {
      this.$emit('hide')
    },
    share: function (src) {
      let shareUrl = null
      const encodedUrl = encodeURIComponent(parent.document.location.toString().split('#')[0])
      const subject = encodeURIComponent('@GE_Digital SCADA Superhero game')
      let message = ('I challenge you to play the GE Digital SCADA Superhero game!\n')
      if (this.score) {
        message = ('I just played @GE_Digital SCADA Superhero game and had a blast, try to beat my score of <score>!\n\n'.replace('<score>', this.score))
        if (src === 'email') {
          message = ('I just played SCADA Superhero and had a blast, check it out and try to beat my score of <score> in Challenge <challenge>!\n\n'.replace('<score>', this.score).replace('<challenge>', this.challenge))
        }
      }
      if (src === 'facebook') {
        message = message.replace('@GE_Digital', '@GEDigital')
      }
      message = encodeURIComponent(message)
      let popup = false
      if (src === 'facebook') {
        shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl + '&quote=' + message
        popup = true
      }
      if (src === 'twitter') {
        shareUrl = 'https://twitter.com/intent/tweet?text=' + message + '&url=' + encodedUrl
        popup = true
      }
      if (src === 'linkedin') {
        shareUrl = 'https://www.linkedin.com/shareArticle?mini=true&title=' + message + '&url=' + encodedUrl
        popup = true
      }
      if (src === 'email') {
        shareUrl = 'mailto:?body=' + message + encodedUrl + '&subject=' + subject
      }
      if (shareUrl && popup) {
        window.open(shareUrl, 'share', 'width=600,height=400')
      }
      if (shareUrl && !popup) {
        window.open(shareUrl, '_blank')
      }
    }
  },
  props: {
    active: Boolean,
    score: Number,
    challenge: Number
  },
  watch: {
    active: function (newValue) {
      this.visible = newValue
    }
  }
}
</script>

<style scoped lang="scss">
.share-dialog{
  .dialog-content{
    width: 540px;
  }
  p{
    text-align: center;
    text-align: left;
  }
  h2{
    font-weight: normal !important;
    text-align: left;
    img{
      width: 28px;
    }
  }
  p.score{
    color: #444;
  }
}
.share-icons{
  display: flex;
  justify-content: center;
  .share-icon{
    width: 80px;
    height: 80px;
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: #00B5E2;
    border-radius: 4px;
    margin: 30px 20px 0px 20px;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover{
      background-color: #005EB8;
    }
  }
}
@media (max-height: 700px) {
  .share-icons{
    .share-icon{
      width: 60px;
      height: 60px;
      img{
        width: 35px;
        height: 35px;
      }
    }
  }
  .share-dialog{
    h2{
      img{
        width: 24px;
      }
    }
    .dialog-content{
      width: 460px;
    }
  }
}
@media (max-height: 600px) {
  .share-dialog{
    .dialog-content{
      width: 400px;
    }
  }
  .share-icons .share-icon{
    margin: 24px 16px 0px 16px;
    width: 52px;
    height: 52px;
    img{
      width: 32px;
      height: 32px;
    }
  }
}
</style>
